import React, { useRef } from 'react';
import cn from 'clsx';
import { LinkWithGAPromoClick, Section } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { PromoBanner, usePromoBlockSelector } from 'modules/model-json';
import { createElementKey } from 'utils';
import {
  PROMO_BLOCK_CARDS_MAP_GRID,
  promoBlock,
  promoBlockBg,
  promoBlockCard,
  promoBlockCards,
} from './promo-block-styles';

export type PromoBlockProps = {
  elementBlock: string;
  position?: number;
};

export const PromoBlock: React.FC<PromoBlockProps> = ({ elementBlock, position = 0 }) => {
  const bannerRefs = useRef<HTMLAnchorElement[]>([]);
  const promoBlockData = usePromoBlockSelector(position);

  const promotions = promoBlockData?.promoCards
    ? promoBlockData?.promoCards?.map(({ creative }, index: number) => ({
      name: elementBlock,
      creative,
      position: (index + 1).toString(),
    }))
    : [];

  usePromoViewEvent(bannerRefs, elementBlock, promotions);

  if (!promoBlockData) {
    return null;
  }

  const { background, promoCards } = promoBlockData;

  return (
    <Section>
      <div className={promoBlock}>
        <picture>
          <source srcSet={background.bannerLargeRef} media={strictBreakpoints['--only-largeDesktop']} />
          <source srcSet={background.bannerDesktopRef} media={strictBreakpoints['--only-desktop']} />
          <source srcSet={background.bannerTabletRef} media={strictBreakpoints['--only-tablet']} />
          <img className={promoBlockBg} src={background.bannerMobileRef} />
        </picture>
        <div className={cn(promoBlockCards, PROMO_BLOCK_CARDS_MAP_GRID[promoCards.length])}>
          {promoCards.map((card: PromoBanner, index: number) => (
            <LinkWithGAPromoClick
              className={promoBlockCard}
              bannerRefs={bannerRefs}
              position={index}
              promotion={promotions[index]}
              elementBlock={elementBlock}
              key={createElementKey('promo-block-card', index)}
              href={card.bannerUrl}
              title={card.creative}
              target="_blank"
            >
              <picture>
                <source srcSet={card.bannerLargeRef} media={strictBreakpoints['--only-largeDesktop']} />
                <source srcSet={card.bannerDesktopRef} media={strictBreakpoints['--only-desktop']} />
                <source srcSet={card.bannerTabletRef} media={strictBreakpoints['--only-tablet']} />
                <img alt={card.gaName} src={card.bannerMobileRef} />
              </picture>
            </LinkWithGAPromoClick>
          ))}
        </div>
      </div>
    </Section>
  )
}
